import React from 'react';
import Stars from 'components/Stars';
import './ReviewStars.scss';
import classnames from 'classnames';
import Label from 'components/form/Label/Label';
import { CSTooltip } from 'components/Tooltip/CSToolTip';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { ReactComponent as StarFullYellow } from 'style/_assets/icons/star-full-yellow.svg';
import { CREDIT_CARD_VERTICAL } from 'types/marketplaceTiles.constants';
import { useConfig } from 'hook/config.hook';

const TooltipTitleComponent = props => {
  const {
    titleLabel,
    tooltip,
    vertical = CREDIT_CARD_VERTICAL,
    customClass = 'fontNeutral300 text-12 margt2 m-text-right',
  } = props;
  return (
    <Label type="Subtitle-3" className={customClass} tabIndex={-1}>
      <CSTooltip
        title={tooltip}
        isInline={true}
        className="predictedLimit__tooltipContainer"
        tooltipName={titleLabel}
        pagePosition={props.pagePosition}
        vertical={vertical}
        placement="bottomLeft"
      >
        {titleLabel}{' '}
        <QuestionCircleOutlined
          style={{
            display: 'inline-block',
            position: 'relative',
            top: -3,
          }}
        />
      </CSTooltip>
    </Label>
  );
};

const RatingStars = props => {
  const {
    badgeCustomClass,
    offerMetadata,
    reviewRatingDisplay,
    onClick,
    ratingFontColorClass,
  } = props;
  return (
    <FlexContainer
      className={classnames('items-align-center', badgeCustomClass)}
      onClick={onClick}
    >
      <StarFullYellow width="24" />
      <Label type="Body-2" className={ratingFontColorClass}>
        {' '}
        {reviewRatingDisplay}
        <span className={'totalComments'}>
          {'('}
          {offerMetadata?.totalComments ? offerMetadata?.totalComments : 0}
          {')'}
        </span>
      </Label>
    </FlexContainer>
  );
};

const DetailsControlRatingStars = props => {
  const { badgeCustomClass, reviewRatingDisplay, offerMetadata, onClick } =
    props;
  const reviewCount = offerMetadata?.totalComments;
  const starCount = offerMetadata?.reviewRating;
  const reviewsAvailable = !!starCount && !!reviewCount;
  if (reviewsAvailable) {
    return (
      <FlexContainer
        className={classnames('flex-column', badgeCustomClass)}
        onClick={onClick}
      >
        <div className="ratingStarSection">
          <div className="offerRating">{reviewRatingDisplay}</div>
          <Stars count={reviewRatingDisplay} starType="yellow" />
        </div>
        <div
          onClick={onClick}
          className="reviewCount"
        >{`${reviewCount} reviews`}</div>
      </FlexContainer>
    );
  } else {
    return (
      <FlexContainer
        className={classnames('flex-column noReviewsView')}
        onClick={onClick}
      >
        <div className="noReviewsYet">No reviews yet.</div>
        <div className="link text-12" onClick={onClick}>
          Write a review
        </div>
      </FlexContainer>
    );
  }
};

const ReviewsRating = props => {
  const {
    containerCustomClass,
    ratingFontColorClass,
    labelCustomClass,
    badgeCustomClass,
    offerMetadata,
    isControlDetails,
    onClick,
    vertical,
  } = props;
  const { config } = useConfig();
  const reviewRatingDisplay =
    !offerMetadata?.reviewRating || offerMetadata?.reviewRating === 0
      ? 'N/A'
      : (Math.round(10 * offerMetadata?.reviewRating) / 10).toFixed(1);

  return (
    <FlexContainer className={classnames('flex-column', containerCustomClass)}>
      <TooltipTitleComponent
        titleLabel={'Reviews'}
        tooltip={config?.disclaimers?.offerReviewsDisclaimer}
        customClass={labelCustomClass}
        vertical={vertical}
      />
      {isControlDetails ? (
        <DetailsControlRatingStars
          badgeCustomClass={badgeCustomClass}
          reviewRatingDisplay={reviewRatingDisplay}
          offerMetadata={offerMetadata}
          onClick={onClick}
        />
      ) : (
        <RatingStars
          badgeCustomClass={badgeCustomClass}
          reviewRatingDisplay={reviewRatingDisplay}
          offerMetadata={offerMetadata}
          ratingFontColorClass={ratingFontColorClass}
          onClick={onClick}
        />
      )}
    </FlexContainer>
  );
};

export default ReviewsRating;
